import React from "react";
import { Form } from "react-final-form";
import { Col, Row } from "reactstrap";
import PromptModal from "src/components/ConfirmationModal/PromptModalV2";
import SimpleDatePickerField from "src/components/Form/SimpleDatePickerFieldV2/SimpleDatePickerField";
import SingleSelectField from "src/components/Form/SingleSelectFieldV2/SingleSelectField";
import TextField from "src/components/Form/TextFieldV2/TextFieldV2";
import * as S from "src/constants/StringConstants";
import { IOption } from "src/store/models/option.model";
import { addDefaultOption } from "src/util/utils.defaultValues";

interface CarrierModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (values) => void;
  selectCarrierList: IOption[];
}

export const CarrierModal: React.FC<CarrierModalProps> = ({ open, onClose, onConfirm, selectCarrierList }) => {
  const validate = values => {
    const errors: Record<string, any> = {};
    if (!values.carrierID) {
      errors.carrierID = S.FORM_FIELD_REQUIRED;
    }
    return errors;
  };

  return (
    <Form
      validate={validate}
      onSubmit={values => {
        if (!values.carrierID) {
          return;
        }
        onConfirm(values);
      }}
      render={({ handleSubmit }) => (
        <PromptModal
          width="60rem"
          open={open}
          onConfirm={handleSubmit}
          onReject={onClose}
          title={S.BRO_CONTRACTING_MODAL_TITLE}
          confirmText={S.BRO_CONTRACTING_SAVE}
          rejectText={S.UDM_CANCEL_BUTTON}>
          <form onSubmit={handleSubmit}>
            <Row>
              <Col sm="6">
                <SingleSelectField
                  name="carrierID"
                  label={S.BRO_CONTRACTING_CARRIER}
                  options={addDefaultOption("", selectCarrierList)}
                />
              </Col>
              <Col sm="6">
                <TextField name="streetLevelPercentage" label={S.BRO_COMMISSIONS_STREET_LVL} />
              </Col>
            </Row>
            <Row>
              <Col sm="6">
                <SimpleDatePickerField name="startDate" label={S.BRO_COMMISSIONS_START_DATE} isFormMode />
              </Col>
              <Col sm="6">
                <TextField name="overridePercentage" label={S.BRO_COMMISSIONS_OVERRIDE} />
              </Col>
            </Row>
          </form>
        </PromptModal>
      )}
    />
  );
};

export default CarrierModal;
